// Default URLs for legal pages (Terms of Service and Privacy Policy)
// Used as fallback when URLs are not provided via widget config
export const DEFAULT_TERMS_URL = 'https://app.shiftgears.ai/terms';
// Страница пока показывает те же T&C — отдельного текста Privacy Policy ещё
// нет (#1387). Ссылка ведёт на свой адрес, чтобы подстановка настоящего текста
// была правкой одного компонента в b2b-ui, без передеплоя виджета.
export const DEFAULT_PRIVACY_URL = 'https://app.shiftgears.ai/privacy-policy';
